;(function () {
  angular
    .module('contrast.application-libraries')
    .controller(
      'AppLibrariesCtrl',
      function (
        $scope,
        UserService,
        LibrariesStatsVisibilityService,
        onboardingTutorialConstants
      ) {
        'ngInject'

        function init() {
          //call parent method
          $scope.setStatsLoaded(false)

          if (
            $scope.model.appLibStatsVisible.visible &&
            !$scope.model.appLibStatsLoaded
          ) {
            $scope.getStats()
          }
        }

        angular.extend($scope, {
          model: {
            appLibStatsVisible: LibrariesStatsVisibilityService.model
          },

          tutorial: UserService.createOnboardingTutorialItem(
            onboardingTutorialConstants.TUTORIAL_TYPE.APP_LIBRARIES
          )
        })

        init()
      }
    )
})()
